import { addToast } from '@ydistri/utils';
import { Modal } from 'antd';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { ReduxState, useAppDispatch } from '../../store';
import { problemMessagesOf } from '../Configuration/Validator/problemsLib';
import { useDeleteAiPromptMutation } from '../ProjectAdministration/AiPrompts/apiAiPrompts';
import { AvailableModals, closeModal } from './modalSlice';

const modalId = AvailableModals.AI_PROMPT_DELETE;

const AiPromptDeleteModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const aiPrompt = useSelector((state: ReduxState) => state.modal.modalData[modalId]?.aiPrompt);

  const [deleteAiPrompt, { isLoading: deleting }] = useDeleteAiPromptMutation();

  const handleClose = useCallback(() => dispatch(closeModal()), [dispatch]);

  const handleDelete = useCallback(() => {
    if (!aiPrompt) return;

    deleteAiPrompt(aiPrompt.aiPromptId)
      .unwrap()
      .catch((error: unknown) => {
        dispatch(
          addToast({
            message: problemMessagesOf(error, 'The prompt was not deleted'),
            isError: true,
          }),
        );
      })
      .finally(handleClose);
  }, [aiPrompt, deleteAiPrompt, dispatch, handleClose]);

  if (!aiPrompt) return null;

  return (
    <Modal
      title="Delete this prompt?"
      centered
      open={true}
      okText="Delete"
      cancelText="Cancel"
      okButtonProps={{ danger: true, loading: deleting }}
      onOk={handleDelete}
      onCancel={handleClose}
    >
      <strong>{aiPrompt.title}</strong>
      <p>It stays stored with all its versions.</p>
    </Modal>
  );
};

export default AiPromptDeleteModal;
